import { c as _c } from "react/compiler-runtime";
import type { DetailedHTMLProps, InputHTMLAttributes, LabelHTMLAttributes } from 'react';
import { Typography } from '@/components/Typography';
import { FleetTypeThumbnail } from '@/components/thumbnails/FleetTypeThumbnail/FleetTypeThumbnail';
import type { V2FleetType } from '@/services/rental-api-client';
export interface FleetTypeRadioProps extends Omit<DetailedHTMLProps<LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement>, 'onChange'> {
  fleetType: V2FleetType;
  name: string;
  value?: InputHTMLAttributes<HTMLInputElement>['value'];
  onChange?: InputHTMLAttributes<HTMLInputElement>['onChange'];
}
export function FleetTypeRadio(t0) {
  const $ = _c(29);
  let fleetType;
  let name;
  let onChange;
  let props;
  let value;
  if ($[0] !== t0) {
    ({
      name,
      fleetType,
      value,
      onChange,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = fleetType;
    $[2] = name;
    $[3] = onChange;
    $[4] = props;
    $[5] = value;
  } else {
    fleetType = $[1];
    name = $[2];
    onChange = $[3];
    props = $[4];
    value = $[5];
  }
  const t1 = fleetType.slug;
  let t2;
  if ($[6] !== fleetType) {
    t2 = <FleetTypeThumbnail fleetType={fleetType} />;
    $[6] = fleetType;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== fleetType.minimumDriverAge || $[9] !== fleetType.name) {
    t3 = <Typography variant="paragraph-heavy" as="div">{fleetType.name} (Must be {fleetType.minimumDriverAge}+)</Typography>;
    $[8] = fleetType.minimumDriverAge;
    $[9] = fleetType.name;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== fleetType) {
    t4 = getFleetTypeTagLine(fleetType);
    $[11] = fleetType;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t4) {
    t5 = <Typography variant="caption" as="div" className="text-base-content/60">{t4}</Typography>;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t3 || $[16] !== t5) {
    t6 = <div className="flex flex-col gap-[3px] flex-1">{t3}{t5}</div>;
    $[15] = t3;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  const t7 = value === fleetType.slug;
  let t8;
  if ($[18] !== fleetType.slug || $[19] !== name || $[20] !== onChange || $[21] !== t7) {
    t8 = <input name={name} type="radio" className="hidden" value={fleetType.slug} checked={t7} onChange={onChange} />;
    $[18] = fleetType.slug;
    $[19] = name;
    $[20] = onChange;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== fleetType.slug || $[24] !== props || $[25] !== t2 || $[26] !== t6 || $[27] !== t8) {
    t9 = <label key={t1} className="overflow-hidden rounded-lg border border-[#dfdfdf] has-checked:border-active hover:not-has-checked:bg-primary-accent p-3 flex gap-[15px] items-center h-18 input-focus-transition user-select-none cursor-pointer" {...props}>{t2}{t6}{t8}</label>;
    $[23] = fleetType.slug;
    $[24] = props;
    $[25] = t2;
    $[26] = t6;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
}
function getFleetTypeTagLine(fleetType: V2FleetType) {
  if (fleetType.slug === 'car') {
    return 'Seats 1-5';
  }
  if (fleetType.slug === 'motorhome') {
    return 'Seats 2-6 | Sleeps 2-6';
  }
  return 'Seats 1-4 | Sleeps 1-4';
}